import { AppType } from "./app-types";
import { EnvironmentMode } from "./environment-mode";

export interface ISignLanguageConfig {
	enabled: boolean;
	scriptUrl: string;
	apiKey?: string;
}

export interface IVelentsWidgetConfig {
	enabled: boolean;
	authToken: string;
}

export interface IEnvironment {
	production: boolean;
	mode: EnvironmentMode;
	defaultTheme: "light" | "dark";
	enableThemeSwitch: boolean;
	enableAccessibilityTools: boolean;
	tokenPropertyName: string;
	refreshTokenPropertyName: string;
	userRolePropertyName: string;
	appTypePropertyName: string;
	mojLoginDataPropertyName: string;
	defaultAppType: AppType;
	domainBasedOnAppType: Partial<Record<AppType, { apiBaseUrl: string }>>;
	i18n_Configurations: {
		defaultLanguage: string;
	};
	isLogoutRedirectUrl?: boolean;
	logoutRedirectUrl?: string;
	idle?: {
		enabled?: boolean;
		timeoutSeconds?: number;
		lastActivityKey?: string;
	};
	nafath?: {
		isEnableNafath: boolean;
		isShowSwitchEnableNafath?: boolean;
		mockConfirmationCode?: string;
		mockAutoCloseDelayMs?: number;

		nafathGatewayRedirectProductionOnly?: boolean;
		allowGatewayRedirectInDevelopment?: boolean;
		allowNafathStatusPollingInDevelopment?: boolean;
		integrationLoginCallbackApiKey?: string;
		nafathReturnUrl?: string;
	};
	lawyerOidc?: {
		authority: string;
		clientId: string;
		scope?: string;
	};
	hideAttorneyRepresentativeOption?: boolean;
	showChatbot?: boolean;
	enableAiTextAssist?: boolean;
	signLanguage?: ISignLanguageConfig;
	velentsWidget?: IVelentsWidgetConfig;
	encryptKeyParts?: readonly string[];
	enableLookupCache?: boolean;
	lookupCacheTtlMs?: number;
	isDgaFilter: boolean;
}

export function getEnvironmentApiBaseUrl(config: IEnvironment): string {
	const key = config.defaultAppType;
	const entry = config.domainBasedOnAppType[key];
	if (!entry?.apiBaseUrl) {
		throw new Error(`IEnvironment: domainBasedOnAppType is missing "${String(key)}" (defaultAppType).`);
	}
	return entry.apiBaseUrl;
}
